import { render, staticRenderFns } from "./SelectTag.vue?vue&type=template&id=9a071b66&scoped=true&"
import script from "./SelectTag.vue?vue&type=script&lang=js&"
export * from "./SelectTag.vue?vue&type=script&lang=js&"
import style0 from "./SelectTag.vue?vue&type=style&index=0&id=9a071b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a071b66",
  null
  
)

export default component.exports